import React, { useState } from "react"
import { StaticQuery, graphql } from "gatsby"
import SocialLinks from "./social-links";
import AsideNavigation from "./aside-navigation"
import Logo from "../assets/planet-argon-logo.svg";


const FixedHeader = () => {
  const [isOpen, setIsOpen] = useState(false)

  function handleClick() {
    if (!isOpen) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }

  // https://www.w3schools.com/howto/howto_js_navbar_hide_scroll.asp
  if (typeof window !== 'undefined') {
    window.onscroll = function () {
      let headerHeight = document.getElementById("is-header").offsetHeight;
      let currentScrollPos = window.pageYOffset;
      if  ( currentScrollPos <= headerHeight ) {
        document.getElementById("is-fixed-header").classList.remove("is-fixed");
      } else {
        document.getElementById("is-fixed-header").classList.add("is-fixed");
      }
    }
  }

  return (
    <StaticQuery
    query={graphql`
      {
        file(sourceInstanceName: {eq: "settings"}, name: {eq: "site-settings"}) {
          id
          name
          childMarkdownRemark {
            html
            frontmatter {
              site_title
              results_year
            }
          }
        }
      }
    `}
    render={data => (
      <nav id="is-fixed-header" className="navbar is-fixed-header has-background-primary has-text-white">
        <div className="is-fixed-header-container">
          <div className="columns is-fixed-header-column is-desktop">
            <div className="column is-3 header-border-right desktop-only">
              <div className="is-fixed-header-logo">
                <a href="http://www.planetargon.com" target="_blank">
                  <img src={Logo} alt="Planet Argon" />
                </a>
              </div>
            </div>
            <div className="column is-fixed-header-details">
              {/* <div className="is-fixed-header-descriptor">Proudly Presents</div> */}
              <div className="level">
                <div className="level-left is-fixed-header-headline">
                  <span className="is-family-sans-serif has-text-weight-semibold">{data.file.childMarkdownRemark.frontmatter.results_year} </span>
                  <span className="ml-1">{data.file.childMarkdownRemark.frontmatter.site_title}</span>
                </div>
                <div className="level-right is-hidden-mobile">
                  {/* <SocialLinks customClass="is-fixed-header-links is-hidden-mobile" showFullEmail={false} /> */}
                </div>
                <a role="button" className="navbar-burger" data-target="navMenu" aria-label="menu" aria-expanded="false" onClick={handleClick}>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                </a>
                <div className={`navbar-menu ${isOpen ? 'is-active' : ''}`} id="navMenu">
                  <AsideNavigation
                    isLinkClicked={handleClick}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <SocialLinks customClass="is-fixed-header-links is-hidden-mobile" showFullEmail={false} />
      </nav>
    )}
  ></StaticQuery>
  );
}

export default FixedHeader;